import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { CHICKEN_CHARTS_DASHBOARD, CHICKEN_DASHBOARD } from '../../constants/routes.constants';
import routes from '../../routes';
import ChickenDashboardMaterialsContext from '../../contexts/ChickenDashboardMaterialsContext';

const DashboardRoutes = ({ setChangedSearch, materials }) => {
  const summaryRoute = routes.find(item => item.path === CHICKEN_DASHBOARD);
  const chartsRoute = routes.find(item => item.path === CHICKEN_CHARTS_DASHBOARD);
  
  if (!summaryRoute && !chartsRoute) {
    return null;
  }
  
  return (
    <Switch>
      {summaryRoute ? (
        <Route
          exact
          path={summaryRoute.path}
          render={props => {
            return (
              <ChickenDashboardMaterialsContext.Provider value={materials}>
                <summaryRoute.component {...props} setChangedSearch={setChangedSearch} />
              </ChickenDashboardMaterialsContext.Provider>
            );
          }}
        />
      ) : null}
  
      {chartsRoute ? (
        <Route
          exact
          path={chartsRoute.path}
          component={chartsRoute.component}
        />
      ) : null}
    </Switch>
  );
};

export default DashboardRoutes;